(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["af_retailer-section"]) return;
  try {
    
const convertLatLngAJLext = ( num ) => {
    if (!num || Number.isNaN(num)) {
        return 0;
    }
    return Number.parseFloat(num);
};


const afIcon = L.divIcon({
    className: 'red-dot',
    html: '<i class="fas fa-car"></i>',
    iconSize: [7,7],
	iconAnchor: [4,4],
    clickable: true
});

mymapajlext = L.map('mapid').setView([20.458977, 17.092039], 2);
// L.tileLayer('https://{s}.tile.openstreetmap.org/hot/{z}/{x}/{y}.png', {
//    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
//    maxZoom: 18,
//    id: 'mapbox.streets',
//    accessToken: 'your.mapbox.access.token'
// }).addTo(mymapajlext);


//L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
//   attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, Imagery &copy; <a href="https://www.mapbox.com/">Mapbox</a>',
//   maxZoom: 18,
//   id: 'mapbox.streets',
//   accessToken: 'pk.eyJ1IjoiYW5mZHJ1bWNvIiwiYSI6ImNqcXBpM2g4NjAxc3M0Mmw1b2xteTZwOTkifQ.QsBTVrqWhBHs-3yGrPkAYA'
//}).addTo(mymapajlext);

L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
   attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, Imagery &copy; <a href="https://www.mapbox.com/">Mapbox</a>',
   tileSize: 512,
   maxZoom: 18,
   zoomOffset: -1,
   id: 'mapbox/streets-v11',
   accessToken: 'pk.eyJ1IjoiYW5mZHJ1bWNvIiwiYSI6ImNqcXBpM2g4NjAxc3M0Mmw1b2xteTZwOTkifQ.QsBTVrqWhBHs-3yGrPkAYA'
}).addTo(mymapajlext);


const sectionBlockDom = document.getElementsByClassName('section-block-count');
const numberOfRetailers = sectionBlockDom && sectionBlockDom.length > 0 ? sectionBlockDom[0].dataset.blocks : 0;
const mapHeight = sectionBlockDom && sectionBlockDom.length > 0 ? Number.parseInt(sectionBlockDom[0].dataset.mapheight) : 300;


let retailers = [];
for (let i=1; i<=numberOfRetailers; i++) {
	const byRow = document.getElementsByClassName('section-block-row-' + i);
    let newRetailer = {};
    newRetailer['title'] = byRow[0].dataset.title;
    newRetailer['latitude'] = byRow[0].dataset.latitude;
    newRetailer['longitude'] = byRow[0].dataset.longitude;
    newRetailer['address'] = byRow[0].dataset.address;
    newRetailer['phone'] = byRow[0].dataset.phone;
    newRetailer['url'] = byRow[0].dataset.url; 
    retailers.push(newRetailer);
}
                                   
for (let i=0; i < retailers.length; i++) {
    const myLat = convertLatLngAJLext(retailers[i].latitude);
    const myLon = convertLatLngAJLext(retailers[i].longitude);
    if(myLat !== 0 && myLon !== 0) {
		let markerRet = L.marker([myLat, myLon], {icon: afIcon}).addTo(mymapajlext);
		const title = `<div class='popup-title'>${retailers[i].title}</div>` || '';
        const address = `<div class='popup-address'>${retailers[i].address}</div>` || '';
        const url = `<div class='popup-url'><a href="${retailers[i].url}" target="_blank">website</a></div>` || '';
        const phone = `<div class='popup-phone' ><a href='tel:${retailers[i].phone}'>${retailers[i].phone}</a></div>` || '';
    	markerRet.bindPopup(`<div class='popup-wrapper'>${title}${address}${url}${phone}</div>`);
	}
}

<!-- The sole purpose of this call is to force the tiles to reload -->
setTimeout(function() {
	let mapRef = document.getElementById("mapid");
	if(mapRef) {
		const newMapHeight = `${mapHeight +1}px`;
		mapRef.style.height=newMapHeight;
		mymapajlext.invalidateSize();
	}
	let startFocusId = document.getElementById("af-retailers-section-start");
	if(startFocusId) {
		startFocusId.focus();
	}
},1500);


  } catch(e) { console.error(e); }
})();
})();
